import React from "react";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import SectionCard from "./SectionCard";

export default function TemplateCanvas({
  sections,
  selectedField,
  onSelectField,
  onSelectSection,
  onUpdateSectionTitle,
  onRemoveSection,
  onAddSection,
}) {
  const sectionIds = (sections || []).map((section) => `section:${section.id}`);

  return (
    <section className="rounded-xl border bg-white p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Form Canvas</h3>
          <p className="text-xs text-gray-500">Bouw je template op uit secties en velden.</p>
        </div>
        <button
          type="button"
          onClick={onAddSection}
          className="rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 hover:bg-gray-50"
        >
          Sectie toevoegen
        </button>
      </div>

      <div className="space-y-3">
        <SortableContext items={sectionIds} strategy={verticalListSortingStrategy}>
          {(sections || []).map((section) => (
            <SectionCard
              key={section.id}
              section={section}
              selectedField={selectedField}
              onSelectField={onSelectField}
              onSelectSection={onSelectSection}
              onUpdateSectionTitle={onUpdateSectionTitle}
              onRemoveSection={onRemoveSection}
            />
          ))}
        </SortableContext>
      </div>
    </section>
  );
}
